import { ActionTree } from 'vuex'
import { INavigationState } from './types'

const actions: ActionTree<INavigationState, any> = {
    toggleSecondLevel({ commit, getters }) {
        commit('setSecondLevelOpen', !getters['isSecondLevelOpen'])
    },

    resetNavigation({ commit }) {
        commit('reset')
    },

    setActiveTopLevelItem({ commit }, itemIndex) {
        commit('setActiveTopLevelItem', itemIndex)
    },

    setActiveSecondLevelItem({ commit }, itemIndex) {
        commit('setActiveSecondLevelItem', itemIndex)
    },

    closeEventsLevel({ commit, getters }) {
        commit('setEventsPanelOpen', false)
        commit('setActiveSecondLevelItem', null)
    },
}

export default actions
